import React from "react";
import { Link } from "react-router-dom";
import * as actions from '../Actions';
import DiscussionActionCounts from './DiscussionActionCounts';
import Service from '../../service/Service';
import { useEffect } from "react";
const service = new Service();


export default function DiscussionContent({ discussion, linkUrl, isDisLanding, eleRef }) {
    useEffect(() => {
        const lazyImages = document.querySelectorAll('.loadingImg[data-src]');
        lazyImages.forEach(img => {
            const dataSrc = img.getAttribute('data-src');
            if (dataSrc) {
                img.setAttribute('src', dataSrc);
                img.removeAttribute('data-src');
                img.classList.remove('loadingImg');
            }
        });
    }, []);

    return (
        <div className="discussion-content">
            <a href={service.getRedirectUrl(linkUrl)}>
                <div className="discussion-title">
                    {/* <span className="M17_42 dev_discussionTitle">{discussion.title}</span> */}
                    <span className="M17_42 dev_discussionTitle" dangerouslySetInnerHTML={{ __html: discussion.htmlTitle ? discussion.htmlTitle : discussion.title}}></span>
                </div>
            </a>
            <div className="discussion-body">
                <div className="discussion-main">
                    <div className="discussion-summary discussionDetails">
                        <a href={service.getRedirectUrl(linkUrl)}>
                            <div className="discussion-readless">
                                <span className="R14_61 discussionDiscription dev_discussionContent discText">
                                    {/* <span dangerouslySetInnerHTML={{ __html: actions.filterLink(discussion.discription) }}></span> */}
                                    {/* <span id={`moretext_${discussion.discussionId}`}>{discussion.discription}</span> */}
                                    <span id={`moretext_${discussion.discussionId}`} dangerouslySetInnerHTML={{ __html: discussion.htmlDesc ? discussion.htmlDesc : discussion.discription}}></span>
                                    
                                </span>
                            </div>
                        </a>
                        {isDisLanding &&
                            <div className="readmore_popup" data-id={`moretext_${discussion.discussionId}`}>
                                <div className="readmorelink R14_link" onClick={(e) => actions.readMoreClick(e, `moretext_${discussion.discussionId}`)}>Read More</div>
                            </div>
                        }
                        {discussion.urls && discussion.urls.map((url, i) =>
                            <div key={i}>
                                {url.type == 'pdf' &&
                                    <div className="discussion-attachment">
                                        <span className="discussion-pdf">
                                            <a href={url.source} download>
                                                <div data-icon-font="&#xe039;" className="icon dev_discussion-pdf"></div>
                                            </a>
                                        </span>
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                    {discussion.templateId == 0 && discussion.urls && discussion.urls.length > 0 &&
                        <div className="discussion-single-attachment">
                            {discussion.urls[0].source && discussion.urls[0].source != '' &&
                                <span className="discussion-single-image">
                                    <a href={service.getRedirectUrl(linkUrl)}>
                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={discussion.urls[0].source.replace("http://", "https://")} alt="" className="loadingImg dev_discArtImage" />
                                    </a>
                                </span>
                            }
                        </div>
                    }
                    {discussion.templateId == 4 && discussion.urls && discussion.urls.length > 0 && discussion.urls.map((url, i) =>
                        <div key={i} className={`discussion-single-attachment temp${discussion.templateId}`}>
                            {url.source && url.source != '' &&
                                <a href={service.getRedirectUrl(linkUrl)}>
                                    <div className={`template${discussion.templateId}`}>
                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={url.source.replace("http://", "https://")} alt="" className="loadingImg dev_discArtImage" />
                                    </div>
                                </a>
                            }
                        </div>
                    )}
                    {discussion.templateId != 0 && discussion.templateId != 4 && discussion.urls && discussion.urls.length > 0 &&
                        <div className="discussion-multiple-attachment">
                            {discussion.urls.length > 1 ?
                                <div className={`parenting-slider1 tmp_${discussion.templateId}`} id={`slider_${discussion.discussionId}`}>
                                    <ul className={`slider left temp${discussion.templateId}`} data-count={discussion.urls.length}>
                                        {discussion.urls.map((url, i) =>
                                            <li key={i} className={`slide left template${discussion.templateId}`}>
                                                {url.source && url.source != '' &&
                                                    <a href={service.getRedirectUrl(linkUrl)}>
                                                        <img data-key={i} data-src={url.source.replace("http://", "https://")} alt="" className="loadingImg slide-img" />
                                                    </a>
                                                }
                                            </li>
                                        )}
                                    </ul>
                                    <div className="arrows">
                                        <span className="next" onClick={() => service.slideSlider('slider_' + discussion.discussionId, 300, 1000)}><span data-icon-font="h" className="icon"></span></span>
                                        <span className="prev" onClick={() => service.slideSlider('slider_' + discussion.discussionId, -300, 1000)}><span data-icon-font="g" className="icon"></span></span>
                                    </div>
                                </div>
                                :
                                <div className={`parenting-slider1 tmp_${discussion.templateId}`}>
                                    {discussion.urls[0].source && discussion.urls[0].source != '' &&
                                        <div>
                                            <a href={service.getRedirectUrl(linkUrl)}>
                                                <img data-src={discussion.urls[0].source.replace("http://", "https://")} alt="" className="loadingImg dev_discArtImage" />
                                            </a>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <DiscussionActionCounts discussion={discussion} eleRef={eleRef} />
                {discussion.comment && discussion.comment[0] && discussion.comment[0].comment &&
                    (isDisLanding &&
                        <a href={service.getRedirectUrl(linkUrl)}>
                            <div className="latest-comments">
                                {discussion.comment[0].commentUserName ?
                                    <span className="M14_42 latest-comment-user">
                                        {discussion.comment[0].commentUserName}
                                    </span>
                                    :
                                    <span className="M14_42 latest-comment-user">
                                        Community User
                            </span>
                                }
                                {/* <span className="R14_75 latest-comment-desc" dangerouslySetInnerHTML={{ __html: actions.filterLink(discussion.comment[0].comment) }}></span> */}
                                <span className="R14_75 latest-comment-desc">{actions.filterLink(discussion.comment[0].comment)}</span>
                            </div>
                        </a>
                    )
                }
            </div>
        </div>
    );
}
